import { ChipTray } from 'components';

import { CampaignChip } from 'modules/campaign/campaign/CampaignChip';
import { ListCampaign } from 'modules/campaign/campaign/types';
import { ReactNode } from 'react';

type CampaignChipTrayProps = {
  values: ListCampaign[];
  fixedIds?: number[];
  onRemove?: (id: number) => void;
  disabled?: boolean;
  role?: string;
  children?: ReactNode;
};

export function CampaignChipTray({ values, fixedIds, onRemove, disabled, role, children }: CampaignChipTrayProps) {
  return (
    <ChipTray role={role} disabled={disabled}>
      {values.map((campaign) => (
        <CampaignChip
          key={campaign.id}
          campaign={campaign}
          disabled={disabled}
          onRemove={fixedIds?.includes(campaign.id) ? undefined : onRemove}
        />
      ))}
      {children}
    </ChipTray>
  );
}
